module.exports = __webpack_public_path__ + "img/chess_checkerspurple.a986bbb2.png";